import { TextField } from '@mui/material';
import { useState } from 'react';
import { handleSingleLineKeys } from 'src/graphql/entities/custom-attributes/field-view-registry/components/single-line-input';
import { CustomAttributeEditProps } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import { getKindLikeValueSafely } from 'src/graphql/entities/custom-attributes/field-view-registry/utils';
import { useAutoFocusInput } from 'src/utils/hooks/use-autofocus-input';
import { useSettleCallbackOnce } from 'src/utils/hooks/use-settle-callback-once';
import { isValidHttpUrl } from 'src/utils/url';

export const UrlEditor = ({
  value,
  onChange,
  onSave,
  onCancel,
  disabled,
}: CustomAttributeEditProps) => {
  const urlValue = getKindLikeValueSafely(value, 'url') ?? '';
  const inputRef = useAutoFocusInput<HTMLInputElement>();
  const [error, setError] = useState<string | null>(null);
  const callbacks = useSettleCallbackOnce({ onSave, onCancel });

  const submit = () => {
    const trimmed = urlValue.trim();

    if (trimmed !== '' && !isValidHttpUrl(trimmed)) {
      setError('Enter a valid URL (e.g. https://example.com)');
      inputRef.current?.focus();
      return;
    }

    callbacks.onSave();
  };

  return (
    <TextField
      inputRef={inputRef}
      value={urlValue}
      onChange={(event) => {
        setError(null);
        onChange({ kind: 'url', value: event.target.value || null });
      }}
      onBlur={submit}
      onKeyDown={handleSingleLineKeys({ onSave: submit, onCancel: callbacks.onCancel })}
      disabled={disabled}
      size="small"
      fullWidth
      type="url"
      autoComplete="off"
      placeholder="https://..."
      error={!!error}
    />
  );
};
